<template>
<div class="login__content">
	<router-link v-bind:to="'/'">
		<h1>Mandato Aberto</h1>
	</router-link>

	<form  @submit.prevent="checkPassword" class="form--login">
			<div class="form__group">
				<label for="password">Senha</label>

				<input type="password" id="password" placeholder="Senha" minlength="6" v-model="formReset.new_password">
			</div>
			<div class="form__group">
				<label for="repeat-password">Confirme a senha</label>
				<input type="password" id="repeat-password" placeholder="Confirmação de senha" minlength="6" v-model="formReset.password_confirm">

				<div class="form__validation" v-if="(errorsApi && errorsApi.error)">
					<p><i class="fas fa-times-circle-o"></i> {{(errorsApi.error === 'Endpoint not found.') ? 'Houve um erro confirme o link enviado no seu e-mail':'pasword-dont-confirm' | translate | capitalize }}</p>
				</div>
			</div>

			<div class="login__submit">
				<div class="form__validation--success" v-show="successMsg">
					<p><i class="fas fa-check"></i> {{ 'save-with-success' | translate | capitalize }}</p>
				</div>

				<div class="form__group submit__content">
					<button type="submit">
						{{ 'send'  | translate  | capitalize }}
					</button>
				</div>
			</div>
	</form>
</div>
</template>


<script>
	export default {
		name: 'reset-password',
		data() {
			return {
				formReset: {
					new_password: '',
					password_confirm: '',
				},
				successMsg: false,
				errorsApi: { error: false },
			};
		},
		computed: {
			errors() {
				this.errorsApi.error = this.$store.state.error;
			},
			success() {
				return this.$store.state.status;
			},
		},
		methods: {
			checkPassword() {
				if ((this.formReset.new_password !== this.formReset.password_confirm) || (this.formReset.new_password === '' || this.formReset.password_confirm === ''
				)) {
					this.errorsApi.error = true;
				} else {
					this.resetPassword();
				}
			},
			resetPassword() {
				const resetPassword = {
					new_password: this.formReset.new_password,
					token: this.$route.params.token.split('='),
				};
				this.$store.dispatch('resetPassword', resetPassword);
				this.validate();
			},
			validate() {
				if (this.success) {
					this.successMsg = this.success;
					this.$data.formDataPost = {};
				}
			},
			errorForm(obj, field) {
				let erro = '';
				if (obj[field]) {
					erro = true;
				}
				return erro;
			},
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/reset-password/resetPassword.vue